import React from 'react';
import ComingSoon from './ComingSoon';

const Yatch = () => {
  return <ComingSoon title="Yatch Services" />;
};

export default Yatch;
